<template lang="pug">
  b-form-select(
    :value="value"
    :size="size"
    :class="{ 'is-invalid': dirty == true && error == true, 'is-valid': dirty == true && error == false }"
    @input="handleInput"
    )
    option(value="" disabled selected) {{ $t("message.select_option") }}
    option(
      v-for="option in options"
      :value="getDDLValue(option)"
    ) {{ option.bank_acc_no }} - {{ option.payment_desc }} ({{ getBalance(option.payment_mode) }})
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";

export default {
  props: {
    value: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: "md"
    },
    dirty: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    filterBalance: {
      type: Boolean,
      default: false
    },
    operatorID: {
      type: String,
      default: ""
    },
    externalID: {
      type: Number,
      default: 0
    }
  },
  data: () => ({
    options: [],
    balanceList: [],
    feedback: {
      success: true,
      status: ""
    },
    balanceObj: {}
  }),
  computed: {
  },
  mounted: function() {
    this.getBankAccList();
    //this.getProviderBalance();
  },
  methods: {
    getBalance: function (pg) {
      var obj = this.balanceList.filter(ele => { return ele.pg == pg });
      if (obj != null && obj.length > 0)
        return obj[0]['balance'];

      return 0;
    },
    getMinLimit: function (pg) {
      var obj = this.balanceList.filter(ele => { return ele.pg == pg });
      if (obj != null && obj.length > 0 && obj[0]['min_limit'] != null)
        return obj[0]['min_limit'];

      return null;
    },
    // getDDLValue: function(obj) {
    //   return obj.bank_id.toUpperCase().trim() + ' - ' + obj.bank_acc_no.toUpperCase().trim();
    // },
    getDDLValue: function(obj) {
      return obj.bank_id.toUpperCase().trim() + ' - ' + obj.payment_mode.toUpperCase().trim();
    },
    getBankAccList() {
      let url = config.bankListFreeAutoWithdrawalUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        operator_id: this.operatorID
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.options = response.data.dt;
                response.data.dt.forEach(value => {
                  this.getProviderBalance(value["payment_mode"], this.externalID);
                });
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getProviderBalance(pg, external_id) {
      this.loading = true;
      this.$store
        .dispatch("user/getPGProviderBalance", { pg, external_id})
        .then(response => {
          this.loading = false;
          // console.log(response)
          this.feedback.success = response.success;
          this.feedback.status = response.status;
          if (this.feedback.success == true) {
            if (response.obj != null && response.obj !== "undefined") {
              this.balanceList.push(response.obj)
              // this.balanceObj[pg] = response.obj['balance']
              // Emit min_limit data to parent component
              if (response.obj.min_limit != null) {
                this.$emit("min-limit-updated", {
                  pg: pg,
                  min_limit: response.obj.min_limit
                });
              }
            }
          }
        })
        .catch(response => {
          this.loading = false;
          this.feedback.success = response.success;
          // this.submission.status =  response.status;
          this.feedback.status = this.$t("error." + response.status);
        });
    },
    handleInput(e) {
      this.$emit("input", e);
      // Emit min_limit when selection changes (always emit, even if null, to hide label)
      if (e && e.includes(' - ')) {
        var payment_mode = e.split(' - ')[1].trim();
        var min_limit = this.getMinLimit(payment_mode);
        this.$emit("min-limit-changed", {
          payment_mode: payment_mode,
          min_limit: min_limit
        });
      } else {
        // If selection is cleared, emit null to hide the label
        this.$emit("min-limit-changed", {
          payment_mode: null,
          min_limit: null
        });
      }
    }
  }
};
</script>
